import { useContext, useRef } from "react";
import { AuthContext } from "../../Context/authContext";
import Image from "../Reusable/Image";
import SubmitButtonTwo from "../Reusable/Buttontwo";
import { Modal, ModalBody } from "react-bootstrap";
import { SvgImages } from "../../Utils/LocalImages";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import SessionManager from "../../Utils/Session";
import { toast } from "react-toastify";
import { handleApiErrors } from "../../Utils/Utils";
import ApiConstants from "../../Utils/ApiConstant";

const Profilemodal = ({ showModal, setShowModal, title, children, titletwo, submitButtonText, className }) => {
  const { user } = useContext(AuthContext);
  const fileInputRef = useRef(null);

  const getprofilepic = async (file) => {
    try {
      const response = await StudentDashboardServices.getprofilepic(file);
      toast.success("Profile Pic Updated Successfully!");
      SessionManager.shared.storeUserData(response.user);
      setShowModal(false);
      SessionManager.shared.getData()

    } catch (error) {
      handleApiErrors(error);
    }
  };
  const deleteprofilePicture = async () => {
    try {
      const response = await StudentDashboardServices.deleteprofilePicture();
      toast.success("Profile Pic Deleted Successfully!");
      setShowModal(false);
      SessionManager.shared.getData()

    } catch (error) {
      handleApiErrors(error);
    }
  };

  const handleUpdateClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      aria-labelledby="exampleModalToggleLabel2"
      contentClassName="p-0 bg-transparent border-0 shadow-none"
    >
      <ModalBody className="p-0">
        <div>
          <div className="modal-content p-4">
            <div className="modal-header p-0 mb-0" style={{ borderBottom: "none", justifyContent: 'right' }}>
              <Image className="cursor-pointer" src={SvgImages.cross} style={{ height: "20px", aspectRatio: 1 }} onClick={() => setShowModal(false)} />
            </div>
            <div className="modal-body p-0">
              <h2 className="sub-large-text-one text-center fw-700 black mb-3">{title}</h2>
              <div className="d-flex justify-content-center">
                <Image
                  className="modal_profile"
                  id="output"
                  style={{ objectFit: "cover" }}
                  src={user?.profilePicture && user.profilePicture?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + user.profilePicture : SvgImages.user_profile}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = SvgImages.user_profile;
                  }}
                />
              </div>
              {children}
            </div>
            <div className="modal-footer p-0 mt-3" style={{ borderTop: 'none', justifyContent: 'center' }}>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: 'none' }} // Hide the file input
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    getprofilepic(e.target.files[0]);
                  }
                }
                } />
              <SubmitButtonTwo
                title={submitButtonText}
                className={className}
                onclick={handleUpdateClick} // Trigger file input click
              />

            </div>
            <div>
              <h2 className="small-medium-text text-center fw-600 orangeAccentColor mt-3 mb-0 cursor-pointer" onClick={deleteprofilePicture}>{titletwo}</h2>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default Profilemodal